module.exports = __webpack_public_path__ + "img/time.fbbadbdd.png";